import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { orange } from "@/pages/(app)/home/components/colors";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import useTranslation from "@babackapp/translations/use-translation";
import { ClockIcon } from "@heroicons/react/24/outline";
import { useCallback, useEffect } from "react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import QuickFilterItem from "./quick-filter-item";

export default function ToValidateQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const status = filters.get("status");

  const active = !status && quickFilter === "toBeValidated";

  const onClick = useCallback(() => {
    clearAll();
    setQuickFilter("toBeValidated");
  }, [filters]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "toBeValidated",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <QuickFilterItem
      count={results?.totalCount ?? 0}
      active={active}
      title={t("returnRequestsQuickFilters.toValidate.title")}
      description={t("returnRequestsQuickFilters.toValidate.description")}
      icon={<ClockIcon className="size-3" color={orange} />}
      onClick={onClick}
    />
  );
}
